// extracted by mini-css-extract-plugin
module.exports = {"social_blok":"Hero_social_blok__sBTto"};